import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import utils  from "./static/js/utils";
import VueLazyload from "vue-lazyload";
Vue.use(Element)
Vue.use(VueLazyload)
Vue.prototype.utils = utils


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
